// ------------------------------------------
// 施工事例詳細の関連事例スライダー
// ------------------------------------------
class WorksRelatedSlider {
  constructor(el) {
    this.sliders = document.querySelectorAll('.' + el);
    if (this.sliders.length > 0 && typeof Swiper !== 'undefined') {
      this.sliders.forEach((slider) => this.setup(slider));
    }
  }

  setup(slider) {
    const container = slider.querySelector('.swiper-container');
    const count = slider.querySelectorAll('.swiper-slide').length;
    if (count < 2) return;

    new Swiper(container, {
      slidesPerView: 'auto',
      spaceBetween: 13,
      loop: true,
      loopedSlides: count,
      speed: 800,
      grabCursor: true,
      navigation: {
        prevEl: slider.querySelector('.js-works-related-prev'),
        nextEl: slider.querySelector('.js-works-related-next'),
      },
      pagination: {
        el: slider.querySelector('.js-works-related-pagination'),
        clickable: true,
        bulletClass: 'p-works-single__related-bullet',
        bulletActiveClass: 'is-active',
        renderBullet: (i, className) => `<button class="${className}" type="button" aria-label="${i + 1}件目へ"></button>`,
      },
      breakpoints: {
        0: { spaceBetween: 4, centeredSlides: true },
        768: { spaceBetween: 13, centeredSlides: false },
      },
    });
  }
}
